export default __webpack_public_path__ + "static/media/push_notification.e96966f8.svg";